import { DEFAULT_STATE } from "./store";
import { WeatherAction, WeatherState } from "./type";

export function reducer(
	state: WeatherState = DEFAULT_STATE,
	action: WeatherAction,
): WeatherState {
	switch (action.type) {
		case "SET_FORECAST_DATA":
			return {
				...state,
				forecastCity: {
					...state.forecastCity,
					forecast: {
						isLoading: false,
						forecastData: action.forecastData,
						error: null,
					},
				},
			};

		case "SET_FORECAST_LOADING":
			return {
				...state,
				forecastCity: {
					...state.forecastCity,
					forecast: {
						...state.forecastCity.forecast,
						isLoading: action.isLoading,
					},
				},
			};

		case "SET_FORECAST_ERROR":
			return {
				...state,
				forecastCity: {
					...state.forecastCity,
					forecast: {
						...state.forecastCity.forecast,
						error: action.error,
					},
				},
			};

		case "SET_FORECAST_CITY_LOCATION":
			return {
				...state,
				forecastCity: {
					...state.forecastCity,
					location: action,
					selectedDate: new Date(),
				},
			};

		case "SET_FORECAST_USER_LOCATION":
			return {
				...state,
				forecastCity: {
					...state.forecastCity,
					selectedDate: new Date(),
					userLocation: action ?? null,
				},
			};

		case "SET_MARINE_FORECAST_DATA":
			return {
				...state,
				marineForecast: {
					...state.marineForecast,
					marineData: action.marineData,
				},
			};

		case "SET_MARINE_FORECAST_ERROR":
			return {
				...state,
				marineForecast: {
					...state.marineForecast,
					error: action.error,
				},
			};

		case "SET_MARINE_FORECAST_LOADING":
			return {
				...state,
				marineForecast: {
					...state.marineForecast,
					isLoading: action.isLoading,
				},
			};

		case "SET_FORECAST_CITY_DATA":
			return {
				...state,
				forecastCity: {
					...state.forecastCity,
					cities: {
						isLoading: false,
						cityData: action.cityData,
						error: null,
					},
				},
			};

		case "SET_FORECAST_CITY_LOADING":
			return {
				...state,
				forecastCity: {
					...state.forecastCity,
					cities: {
						...state.forecastCity.cities,
						isLoading: action.isLoading,
					},
				},
			};

		case "SET_FORECAST_CITY_ERROR":
			return {
				...state,
				forecastCity: {
					...state.forecastCity,
					cities: {
						...state.forecastCity.cities,
						isLoading: false,
						error: action.error,
					},
				},
			};

		case "SET_DAILY_MARINE_DATA":
			return {
				...state,
				dailyMarine: {
					...state.dailyMarine,
					dayliesData: action.dayliesData,
				},
			};

		case "SET_DAILY_MARINE_LOADING":
			return {
				...state,
				dailyMarine: {
					...state.dailyMarine,
					isLoading: action.isLoading,
				},
			};

		case "SET_DAILY_MARINE_ERROR":
			return {
				...state,
				dailyMarine: {
					...state.dailyMarine,
					error: action.error,
				},
			};

		case "SET_MARINE_LOCATION":
			return {
				...state,
				marineLocation: action.payload,
			};

		case "SET_FORECAST_PREVISION_DATE":
			return {
				...state,
				forecastCity: {
					...state.forecastCity,
					selectedDate: action.date,
				},
			};

		case "SET_DAILY_FORECAST_DATA":
			return {
				...state,
				dailyForecast: {
					...state.dailyForecast,
					dayliesData: action.dayliesData,
				},
			};

		case "SET_DAILY_FORECAST_LOADING":
			return {
				...state,
				dailyForecast: {
					...state.dailyForecast,
					isLoading: action.isLoading,
				},
			};

		case "SET_DAILY_FORECAST_ERROR":
			return {
				...state,
				dailyForecast: {
					...state.dailyForecast,
					error: action.error,
				},
			};

		case "SET_MARINE_STATION_DATA":
			return {
				...state,
				marineStation: {
					...state.marineStation,
					stations: action.stations,
				},
			};

		case "SET_MARINE_STATION_LOADING":
			return {
				...state,
				marineStation: {
					...state.marineStation,
					isLoading: action.isLoading,
				},
			};

		case "SET_MARINE_STATION_ERROR":
			return {
				...state,
				marineStation: {
					...state.marineStation,
					error: action.error,
				},
			};

		case "SET_TIMELINE_DATA":
			return {
				...state,
				timeline: {
					...state.timeline,
					timelineData: action.timelineData,
				},
			};

		case "SET_TIMELINE_LOADING":
			return {
				...state,
				timeline: {
					...state.timeline,
					isLoading: action.isLoading,
				},
			};

		case "SET_TIMELINE_ERROR":
			return {
				...state,
				timeline: {
					...state.timeline,
					error: action.error,
				},
			};

		case "SET_DAILY_FORECAST_STATION_ID":
			return {
				...state,
				dailyForecast: {
					...state.dailyForecast,
					stationIdSelected: action.stationId,
				},
			};

		case "SET_PRAYER_DATA":
			return {
				...state,
				prayer: {
					...state.prayer,
					isLoading: false,
					prayerData: action.prayerData,
					error: null,
				},
			};

		case "SET_PRAYER_LOADING":
			return {
				...state,
				prayer: {
					...state.prayer,
					isLoading: action.isLoading,
				},
			};

		case "SET_WARNING_ERROR":
			return {
				...state,
				warning: {
					...state.warning,
					isLoading: false,
					error: action.error,
				},
			};

		case "SET_WARNING_DATA":
			return {
				...state,
				warning: {
					...state.prayer,
					isLoading: false,
					warningData: action.warningData,
					error: null,
				},
			};

		case "SET_WARNING_LOADING":
			return {
				...state,
				warning: {
					...state.warning,
					isLoading: action.isLoading,
				},
			};

		case "SET_TIDES_ERROR":
			return {
				...state,
				tide: {
					...state.tide,
					isLoading: false,
					error: action.error,
				},
			};

		case "SET_TIDES_DATA":
			return {
				...state,
				tide: {
					...state.tide,
					isLoading: false,
					tidesData: action.tidesData,
					error: null,
				},
			};

		case "SET_TIDES_LOADING":
			return {
				...state,
				tide: {
					...state.tide,
					isLoading: action.isLoading,
				},
			};

		case "SET_TIDES_ERROR":
			return {
				...state,
				tide: {
					...state.tide,
					isLoading: false,
					error: action.error,
				},
			};

		case "SET_KUWAIT_FORECAST_DATA":
			return {
				...state,
				forecastKuwait: {
					...state.forecastKuwait,
					isLoading: false,
					forecastData: action.forecastData,
					error: null,
				},
			};

		case "SET_KUWAIT_FORECAST_LOADING":
			return {
				...state,
				forecastKuwait: {
					...state.forecastKuwait,
					isLoading: action.isLoading,
				},
			};

		case "SET_KUWAIT_FORECAST_ERROR":
			return {
				...state,
				forecastKuwait: {
					...state.forecastKuwait,
					isLoading: false,
					error: action.error,
				},
			};

		case "SET_KUWAIT_FORECAST_DATE":
			return {
				...state,
				forecastKuwait: {
					...state.forecastKuwait,
					selectedDate: action.date,
				},
			};

		case "SET_OBSERVATION_DATA":
			return {
				...state,
				observation: {
					...state.observation,
					stations: {
						isLoading: false,
						stationData: action.stationData,
						error: null,
					},
				},
			};

		case "SET_OBSERVATION_LOADING":
			return {
				...state,
				observation: {
					...state.observation,
					stations: {
						...state.observation.stations,
						isLoading: action.isLoading,
					},
				},
			};

		case "SET_OBSERVATION_ERROR":
			return {
				...state,
				observation: {
					...state.observation,
					stations: {
						...state.observation.stations,
						isLoading: false,
						error: action.error,
					},
				},
			};

		case "SET_OBSERVATION_IMAGERY_DATA":
			return {
				...state,
				observation: {
					...state.observation,
					imageryTiff: {
						isLoading: false,
						imageryData: action.imageryData,
						error: null,
					},
				},
			};

		case "SET_OBSERVATION_IMAGERY_LOADING":
			return {
				...state,
				observation: {
					...state.observation,
					imageryTiff: {
						...state.observation.imageryTiff,
						isLoading: action.isLoading,
					},
				},
			};

		case "SET_OBSERVATION_FILTER":
			return {
				...state,
				observation: {
					...state.observation,
					imageryFilter: action.filter,
				},
			};

		case "SET_OBSERVATION_IMAGERY_ERROR":
			return {
				...state,
				observation: {
					...state.observation,
					imageryTiff: {
						...state.observation.imageryTiff,
						isLoading: false,
						error: action.error,
					},
				},
			};

		case "SET_OBSERVATION_DATE":
			return {
				...state,
				observation: {
					...state.observation,
					selectedDate: action.date,
				},
			};

		case "SET_WORLD_CITIES_DATA":
			return {
				...state,
				worldForecast: {
					...state.worldForecast,
					cities: {
						isLoading: false,
						cityData: action.worldCitiesData,
						error: null,
					},
				},
			};

		case "SET_WORLD_CITIES_LOADING":
			return {
				...state,
				worldForecast: {
					...state.worldForecast,
					cities: {
						...state.worldForecast.cities,
						isLoading: action.isLoading,
					},
				},
			};

		case "SET_WORLD_CITIES_ERROR":
			return {
				...state,
				worldForecast: {
					...state.worldForecast,
					cities: {
						...state.worldForecast.cities,
						isLoading: false,
						error: action.error,
					},
				},
			};

		case "SET_WORLD_CITIES_FORECAST_DATE":
			return {
				...state,
				worldForecast: {
					...state.worldForecast,
					selectedDate: action.date,
				},
			};

		case "SET_WORLD_CITIES_FORECAST_DATA":
			return {
				...state,
				worldForecast: {
					...state.worldForecast,
					forecast: {
						isLoading: false,
						error: null,
						forecastData: action.worldCitiesData,
					},
				},
			};

		case "SET_WORLD_CITIES_FORECAST_LOADING":
			return {
				...state,
				worldForecast: {
					...state.worldForecast,
					forecast: {
						...state.worldForecast.forecast,
						isLoading: action.isLoading,
					},
				},
			};

		case "SET_WORLD_CITIES_FORECAST_ERROR":
			return {
				...state,
				worldForecast: {
					...state.worldForecast,
					forecast: {
						...state.worldForecast.forecast,
						isLoading: false,
						error: action.error,
					},
				},
			};

		case "SET_WORLD_CITIES_LOCATION":
			return {
				...state,
				worldForecast: {
					...state.worldForecast,
					selectedLocation: action.payload,
				},
			};

		case "SET_PREVISION_MARINE_DATE":
			return {
				...state,
				previsionMarine: {
					date: action.date,
				},
			};

		default:
			return state;
	}
}
